import { ref, onMounted, onUnmounted } from 'vue'

export function useChatScroll () {
	const isAtBottom = ref<boolean>(false)

	let observer: IntersectionObserver | null = null

	onMounted(() => {
		const sentinel = document.querySelector('[data-chat-bottom-sentinel]')
		const container = document.querySelector('[data-messenger-scrollwrap]')

		if (!sentinel || !container) return

		observer = new IntersectionObserver(
			([entry]) => {
				isAtBottom.value = entry?.isIntersecting || false
			},
			{
				root: container,
				threshold: 0
			}
		)

		observer.observe(sentinel)
	})

	onUnmounted(() => {
		if (observer) {
			observer.disconnect()
		}
	})

	return {
		isAtBottom
	}
}
